import React from 'react'
import { useHistory } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { SingleAnswer, Step } from '../../components'

const PERMISSION = {
  key: 'minor_permission',
  trackingKey: 'adult_permission',
  question:
    'Please confirm that you are using Mote under the direction or supervision of an adult',
  choices: [
    { icon: '👍', text: 'I have permission', value: true },
    { icon: '👎', text: 'I don’t have permission', value: false }
  ]
}

export const StudentMinorPermission = ({ index }) => {
  const history = useHistory()
  const [permissionError, setPermissionError] = React.useState(null)

  function handleChoice(hasPermission) {
    if (hasPermission) {
      if (permissionError) setPermissionError(null)
      history.push('/onboarding/upsell')
    }

    setPermissionError(
      'Unfortunately, you need the consent of an adult to use Mote. Please ask and try again.'
    )
  }

  return (
    <Step
      index={index}
      trackingKey={PERMISSION.trackingKey}
      itemsCount={PERMISSION.choices.length}
      title={PERMISSION.question}
      error={permissionError}
      subtitle='Select one (Required)'
    >
      {PERMISSION.choices.map(({ icon, text, value }) => {
        const hasPermission = !!value

        return (
          <StyledSingleAnswer
            key={`${text}-${value}`}
            question={PERMISSION.question}
            surveyKey={PERMISSION.key}
            text={text}
            icon={icon}
            value={value}
            onClick={() => handleChoice(value)}
            hasError={!hasPermission && Boolean(permissionError)}
            disableAutoNext
          />
        )
      })}
    </Step>
  )
}

const StyledSingleAnswer = styled(SingleAnswer)`
  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #f44336;
      pointer-events: none;
    `}
`
